export enum WorkingHourStatus {
  Approved = "approved",
  PaymentPending = "payment_pending",
  NotApproved = "not_approved",
  Declined = "declined",
}
